import type { TRuleWithTheme } from '@/styles/theme';

export const button: TRuleWithTheme = ({ theme }) => ({
    '&.ant-btn-text': {
        ...theme.typography.ParagraphSmallMedium,

        visibility: 'hidden',
        opacity: 0,
        padding: 0,
        margin: 0,
        gap: '0.25rem',
        lineHeight: 1,
        height: 'auto',

        transition: 'opacity 0.2s ease-in-out',
    },
});
